var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.669,
    height: 281.561,
    viewBox: "0 0 93.669 281.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5ce9d;}.b{fill:#2f518c;}.c{fill:#535763;}.d{fill:#82d0f5;}.e{fill:#a6a6a6;}.e,.j,.m{mix-blend-mode:multiply;}.e,.f,.j,.m{isolation:isolate;}.f{fill:#999;mix-blend-mode:screen;}.g{fill:#bf7b61;}.h{fill:#254566;}.i{fill:#406ebe;}.j{fill:#d4d4d4;}.k{fill:#fff;}.l{fill:#d6924e;}.m{fill:#d9d9d9;}.n{fill:#d1b086;}.o{fill:#734734;}.p{fill:#73564e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129.526 -25.038)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.29,48.876a15.552,15.552,0,0,0-6.382-3.539,9.576,9.576,0,0,1-5.144-3c-1.629-1.567-.537-3.907.455-5.362,1.765-2.592,4.419-4.308,6.4-3.07,2.379,1.5,3.641,2.727,4.284,4.806a10.375,10.375,0,0,0,4,5.6C158.551,45.549,154.32,49.809,153.29,48.876Z",
    transform: "translate(43.735 32.419)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.685 72.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.824,39.849A1.131,1.131,0,0,0,143,41.41c8.374,6.962,16.874,14.757,22.028,18.953a5.079,5.079,0,0,0,6.943-.609h0a4.808,4.808,0,0,0-.822-6.962c-5.391-3.984-14.578-10.511-23.276-17.624a1.142,1.142,0,0,0-1.625.189Z",
    transform: "translate(-142.588 -34.912)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.904 60.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 14.557,
    height: 29.349,
    rx: 0.225,
    transform: "matrix(-0.95, -0.312, 0.312, -0.95, 13.833, 32.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.1,56.229l12.034,3.95a.421.421,0,0,0,.532-.271l7.4-22.551a.423.423,0,0,0-.271-.532l-12.034-3.945a.421.421,0,0,0-.532.271l-7.4,22.551A.418.418,0,0,0,140.1,56.229Z",
    transform: "translate(-138.46 -30.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M142.614,33.315l2.79.914a.229.229,0,0,0,.29-.145l.01-.029a.232.232,0,0,0-.15-.29l-2.785-.914a.225.225,0,0,0-.29.145l-.01.029A.229.229,0,0,0,142.614,33.315Z",
    transform: "translate(-128.308 -30.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M142.294,33.212h0a.222.222,0,0,0,.28-.14l.014-.048a.222.222,0,0,0-.14-.28h0a.225.225,0,0,0-.276.14l-.019.053A.227.227,0,0,0,142.294,33.212Z",
    transform: "translate(-129.511 -30.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M143.7,33.089l8.466,2.775-.227,2.911L145.3,59a.428.428,0,0,1-.513.3l-3.056-1Z",
    transform: "translate(-131.084 -29.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M143.939,58.71l-3.162-1.035L142.426,36.5l1.088-3.322a.424.424,0,0,1,.513-.3l1.876.614Z",
    transform: "translate(-134.754 -30.323)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M170.263,90.356a53.363,53.363,0,0,0,6.755-9.491c1.852-3.472,6.479-11.575,4.748-10.294s3.583-9.786,2.229-9.37,1.334-13.171.222-12.344-3.742-13.267-4.134-11.478-7.707-10.337-7.707-7.968-12.1-6.024-11.038-4.076-11.682-1.035-9.83.759-12.363,2.94-9.767,3.767-8.394,4-4.792,4-4.709,8.742-3.554,8-1.789,6.687-1.1,6.484-1.262,8.689-.106,7.862.053,9.124,1.407,7.6.986,5.5,2.543,8.621C147.389,94.973,170.263,90.356,170.263,90.356Z",
    transform: "translate(8.771 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.677 180.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M154.889,62.357c-.367-7.726-17.232-6.392-16.845,1.774.276,14.491,2.471,32.245,5.333,51.136.121,2.5,3.041,4.4,6.532,4.24h0c3.486-.164,6.218-2.331,6.1-4.835C158.225,96,156.291,78.062,154.889,62.357Z",
    transform: "translate(-138.037 -57.228)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.144 180.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M151.5,62.692c.106-7.736-16.807-7.436-16.923.74-.614,14.481.488,32.332,2.19,51.363-.034,2.509,2.766,4.584,6.261,4.637h0c3.491.048,6.348-1.944,6.387-4.453C152.772,96.479,151.945,78.454,151.5,62.692Z",
    transform: "translate(-134.41 -57.088)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.237,41.97h0c.89,1.745,1.122,3.67-.43,4.859-13.263,10.163-22.58,16.628-29.18,21.153-7.33,5.028-18.61-3.423-12.383-7.649,7.238-4.908,20.955-12.755,35.344-21.158C179.645,37.391,182.12,39.77,183.237,41.97Z",
    transform: "translate(38.011 51.819)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.279 101.656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M135.307,73.682c2.785,5.352,34.629,9.656,34.261,2.659-.609-11.595-1.373-18.185-1.373-18.185l-30.973-1.862C133.479,65.182,134.185,70.824,135.307,73.682Z",
    transform: "translate(-123.544 18.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M142.557,119.23c-.073,1.47,3.728-.073,7.436,4.4,4.69,5.667,28.092,1.2,28.2-.981.222-2.35-1.4-20.244.9-40.74,2.935-26.037,3.394-30.823-5.357-36.418-10.2-4.864-12.832-5.3-20.805-3.95a45.984,45.984,0,0,0-15.7,6.571c-9.467,6.15-4.124,14.007,3.385,38.4C147.421,108.632,142.557,119.23,142.557,119.23Z",
    transform: "translate(-132.163 -40.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M157.877,60.577c-.894-.885-4.052-1.412-4.124-2.326s4.53-.6,4.53-1.789c0-1.649-1.368-9.467-4.453-13.93-5.227-1.992-8.22-1.987-14.084-.991a30.9,30.9,0,0,0-4.144,1.093c.725,5.183,2.877,15.743,3.152,16.6.29.919,4.4.184,5.28.735s-3.525,2.751-2.606,3.941,8.689,10.719,9.733,10.995S158.4,61.094,157.877,60.577Z",
    transform: "translate(-118.975 -40.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M138.515,41.535a25.912,25.912,0,0,0-2.592.633c3.123,5.053,10.647,23.489,13.62,28.242.894,1.422,1.866-20.815,1.373-28.474C146.676,40.563,143.717,40.655,138.515,41.535Z",
    transform: "translate(-117.744 -40.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M140.763,46.444c.58-.58,1.117-1.716.808-2.3-1.083-2.04-1.668-2.693-2.35-2.572-.982.169-1.035.943-1.591,3.036-.218.817.928,1.692,1.668,2.055.034,3.534.358,11.183.459,14.592,1.339,2.853,2.519,5.246,3.346,6.566.392.619.8-3.283,1.088-8.51C143.34,55.877,141.662,49.983,140.763,46.444Z",
    transform: "translate(-111.304 -38.288)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.78,88.988h0a4.047,4.047,0,0,1-2.1-4.738c4.56-16.077,7.992-27.4,10.579-34.972,2.877-8.413,15.724-7.606,14.176-.237-1.987,9.482-9.133,22.879-15.651,38.216C137.4,90.516,133.994,90.085,131.78,88.988Z",
    transform: "translate(0.001 69.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.567,52.111c-1.417,6.232-5.826,12.416-7.823,17.14-.986,2.33-11.251-1.924-10.84-3.912C135.27,51.221,137.4,42.5,142.919,42.45,146.289,42.416,150.868,46.376,149.567,52.111Z",
    transform: "translate(5.239 66.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.892,38.734c.57,2.853.74,10.086-.638,11.8,1.779,2.693,10.4,2.737,12.813-.077-.793-1.538-1.654-7.852-.406-11.725C148.733,38.5,136.892,38.734,136.892,38.734Z",
    transform: "translate(25.804 52.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M147.541,44.275a17.28,17.28,0,0,1,.614-5.541c.072-.237-11.769,0-11.769,0a31.493,31.493,0,0,1,.416,5.715A20.152,20.152,0,0,0,147.541,44.275Z",
    transform: "translate(26.31 52.12)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.418 28.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M142.83,35.21c2.181-3.012,5.594-1.654,4.448,2.978-1.165,4.709-6.813,4.506-6.813,3.839S142.83,35.21,142.83,35.21Z",
    transform: "translate(-101.461 4.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M137.317,35.171c-2.185-3.017-6.31-1.417-4.448,2.978,1.7,4.023,6.813,4.506,6.813,3.839S137.317,35.171,137.317,35.171Z",
    transform: "translate(-132.399 4.066)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.066 4.451)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.033,47.753c.048,9.864,3,28.972,6.527,35.368,3.414,6.2,26.762,7.3,30.519-.218s5.788-33.652,4-41.523S166.84,26.948,155.57,26.769,132.932,27.026,133.033,47.753Z",
    transform: "translate(-133.033 -26.748)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M156.043,38.862c8.418-.082,18.064,1.692,19.722,21.458,3.525-23.431-8.2-34.493-22.261-34.493s-25.341,14.684-18.866,37.607C133.778,45.549,148.974,38.935,156.043,38.862Z",
    transform: "translate(-130.997 -25.827)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M140.243,37.119c0,2.3-1.02,4.158-2.282,4.158s-2.277-1.861-2.277-4.158,1.02-4.158,2.277-4.158S140.243,34.823,140.243,37.119Z",
    transform: "translate(23.618 30.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M144.171,37.119c0,2.3-1.02,4.158-2.277,4.158s-2.282-1.861-2.282-4.158,1.02-4.158,2.282-4.158S144.171,34.823,144.171,37.119Z",
    transform: "translate(38.682 30.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M155.152,37.088c0,1.441-2.514,8.611-9.554,8.249a10,10,0,0,1-9.443-8.558C136.155,35.6,155.152,36.159,155.152,37.088Z",
    transform: "translate(25.424 42.471)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.137 53.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M135.463,38.03l-.778-1.441a.573.573,0,0,1,.232-.778l8.916-4.821a.579.579,0,0,1,.783.232l.778,1.441a.575.575,0,0,1-.237.778l-8.916,4.821A.575.575,0,0,1,135.463,38.03Z",
    transform: "translate(-134.616 -30.921)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.643 53.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M149.064,38.03l.778-1.441a.575.575,0,0,0-.237-.778l-8.911-4.821a.579.579,0,0,0-.783.232l-.778,1.441a.573.573,0,0,0,.232.778l8.916,4.821A.579.579,0,0,0,149.064,38.03Z",
    transform: "translate(-139.064 -30.921)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M142.044,92.38l20.37-.058a2.052,2.052,0,0,0,2.045-2.06V89.9a9.1,9.1,0,0,0-9.133-9.08L141.9,81.1c-1.876.106-1.939,3.805-1.934,4.941l.01,3.389C139.946,91.278,140.724,92.284,142.044,92.38Z",
    transform: "translate(40.055 213.909)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.918 232.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M143.01,131.628c.106,1.726,10.956.479,10.845-1.252-.44-19.78-.155-41.843-2.1-57.943-.164-2.625-3.119-4.588-6.6-4.385h0c-3.486.208-6.184,2.5-6.02,5.125C139.094,90.661,140.82,112.912,143.01,131.628Z",
    transform: "translate(-139.121 -68.033)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M137.051,92.692l20.36-.537a2.046,2.046,0,0,0,2-2.1l-.01-.372a9.106,9.106,0,0,0-9.341-8.863l-13.412.6c-1.876.15-1.847,3.849-1.818,4.98l.087,3.389C134.923,91.638,135.731,92.63,137.051,92.692Z",
    transform: "translate(20.303 213.906)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.797 232.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M135.756,132.187c0,1.731,10.835.614,10.835-1.117.769-19.775,2.422-42.191,1.465-58.383,0-2.63-2.833-4.772-6.329-4.782h0c-3.491-.01-6.319,2.118-6.319,4.748C134.3,90.1,134.717,113.374,135.756,132.187Z",
    transform: "translate(-134.752 -67.905)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M138.109,56.437a15.518,15.518,0,0,0,5.024,5.29,9.591,9.591,0,0,1,4,4.41c1.083,1.987-.658,3.892-2.04,4.98-2.461,1.944-5.512,2.785-7.02,1.006-1.823-2.137-2.659-3.694-2.645-5.865a10.374,10.374,0,0,0-2.142-6.542C132.089,58.033,137.4,55.238,138.109,56.437Z",
    transform: "translate(13.757 119.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M134.424,68.616l-.014-1.373c1.857-.962,5.952-6.682,6.02-9.569,1.455,1.093,3.036,2.949,6.3,3.97C149.664,62.562,135.42,69.235,134.424,68.616Z",
    transform: "translate(18.728 125.162)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.526 150.772)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M155.448,80.665c.416-.522.421-.88,0-1.552-6.769-10.86-12.745-20.414-16.357-25.9-1.45-2.2-5.115-2.829-7.335-1.412h0a4.812,4.812,0,0,0-1.31,6.89c3.926,5.391,11.391,16.531,17.474,25.819.416.629.846.8,1.489.416Z",
    transform: "translate(-129.526 -51.042)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplePhone);
export default __webpack_public_path__ + "static/media/people-phone.b14eb13bf35ddbf2f70b4f08b1c75fab.svg";
export { ForwardRef as ReactComponent };